import { CARDS } from "../../content/index.js";
import { CatalogCard } from "./CatalogCard.js";
import { rewardCatalogCards } from "./catalogFilter.js";

const CARDS_IN_REWARD_POOLS = rewardCatalogCards(Object.values(CARDS));

export function CardCatalogScreen() {
  return (
    <main className="card-catalog">
      <header className="card-catalog-header">
        <p>管理用カード一覧</p>
        <h1>報酬カード</h1>
        <span>全{CARDS_IN_REWARD_POOLS.length}種 · カード下部に出現するPJ規模を表示</span>
      </header>
      <section className="card-catalog-grid" aria-label="報酬カード一覧">
        {CARDS_IN_REWARD_POOLS.map((card) => <CatalogCard card={card} key={card.id} />)}
      </section>
    </main>
  );
}
